import { ActionType } from '../../types';

export const SierraDeviceActions = {
    sierraGatewayDeviceRegistrationStarted: () =>
        ({
            type: 'SierraGatewayDevice/Registration/Started',
        } as const),

    sierraGatewayDeviceRegistrationSucceeded: (message: string, childDevices: string[]) =>
        ({
            type: 'SierraGatewayDevice/Registration/Succeeded',
            payload: { message, childDevices },
        } as const),

    sierraGatewayDeviceRegistrationFailed: (errorCode: string) =>
        ({
            type: 'SierraGatewayDevice/Registration/Failed',
            payload: { errorCode },
        } as const),

    sierraGatewayDeviceRegistrationUnmounted: () =>
        ({
            type: 'SierraGatewayDevice/Registration/Unmounted',
        } as const),

    sierraGatewayDeviceMasterData: (hasData: boolean) =>
        ({
            type: 'SierraGatewayDevice/MasterData/Failed',
            payload: { hasData },
        } as const),

    sierraChildDeviceRegistrationStarted: () =>
        ({
            type: 'SierraChildDevice/Registration/Started',
        } as const),

    sierraChildDeviceRegistrationSucceeded: (message: string) =>
        ({
            type: 'SierraChildDevice/Registration/Succeeded',
            payload: {
                message,
            },
        } as const),

    sierraChildDeviceRegistrationFailed: (errorCode: string) =>
        ({
            type: 'SierraChildDevice/Registration/Failed',
            payload: { errorCode },
        } as const),

    sierraChildDeviceRegistrationUnmounted: () =>
        ({
            type: 'SierraChildDevice/Registration/Unmounted',
        } as const),

    exerthermUnitIdValidation: (unitIdValidation: boolean) =>
        ({
            type: 'SierraChildDevice/UnitIdValidation/exertherm',
            payload: { unitIdValidation },
        } as const),
    sierraGatewayDeviceUpdateStarted: () =>
        ({
            type: 'SierraGatewayDevice/Update/Started',
        } as const),

    sierraGatewayDeviceUpdateSucceeded: (message: string) =>
        ({
            type: 'SierraGatewayDevice/Update/Succeeded',
            payload: { message },
        } as const),

    sierraGatewayDeviceUpdateFailed: (errorCode: string) =>
        ({
            type: 'SierraGatewayDevice/Update/Failed',
            payload: { errorCode },
        } as const),

    sierraGatewayDeviceUpdateReset: () =>
        ({
            type: 'SierraGatewayDevice/Update/Reset',
        } as const),

    sierraChildDeviceUpdateStarted: () =>
        ({
            type: 'SierraChildDevice/Update/Started',
        } as const),

    sierraChildDeviceUpdateSucceeded: (message: string) =>
        ({
            type: 'SierraChildDevice/Update/Succeeded',
            payload: { message },
        } as const),

    sierraChildDeviceUpdateFailed: (errorCode: string) =>
    ({
        type: 'SierraChildDevice/Update/Failed',
        payload: { errorCode },
    } as const),

    deviceDeleteSucceeded: (message: string) =>
    ({
        type: 'Device/Delete/Succeeded',
        payload: { message },
    } as const),

    deviceDeleteFailed: (errorCode: string) =>
    ({
        type: 'Device/Delete/Failed',
        payload: { errorCode },
    } as const),
      

    sierraChildDeviceDeleteStarted: () =>
        ({
            type: 'SierraChildDevice/Delete/Started',
        } as const),

    sierraChildDeviceDeleteSucceeded: (message: string) =>
        ({
            type: 'SierraChildDevice/Delete/Succeeded',
            payload: { message },
        } as const),

    sierraChildDeviceDeleteFailed: (errorCode: string) =>
        ({
            type: 'SierraChildDevice/Delete/Failed',
            payload: { errorCode },
        } as const),
};

export type SierraDeviceActions = ActionType<typeof SierraDeviceActions>;
